import { ChevronLeft, ChevronRight, LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import LanguageSwitcher from '@/components/common/LanguageSwitcher';

interface SidebarFooterProps {
  isCollapsed: boolean;
  onToggleSidebar: () => void;
  onLogout: () => void;
}

export function SidebarFooter({
  isCollapsed,
  onToggleSidebar,
  onLogout,
}: SidebarFooterProps) {
  const { t } = useTranslation();
  const buttonClasses = `flex w-full cursor-pointer items-center rounded-lg py-3 text-sm font-medium text-foreground-inverse transition-colors hover:bg-white/10 ${
    isCollapsed ? 'justify-center px-3' : 'gap-3 px-4'
  }`;

  return (
    <div className="flex flex-col gap-4">
      <div className={isCollapsed ? 'flex justify-center' : ''}>
        <LanguageSwitcher variant={isCollapsed ? 'compact' : 'sidebar'} />
      </div>

      <button
        type="button"
        onClick={onToggleSidebar}
        title={isCollapsed ? t('nav.expandSidebar') : t('nav.collapseSidebar')}
        className={buttonClasses}
      >
        {isCollapsed ? (
          <ChevronRight className="h-5 w-5" />
        ) : (
          <ChevronLeft className="h-5 w-5" />
        )}
        {!isCollapsed && <span>{t('nav.collapseSidebar')}</span>}
      </button>

      <button
        type="button"
        onClick={onLogout}
        title={isCollapsed ? t('nav.logout') : undefined}
        className={buttonClasses}
      >
        <LogOut className="h-5 w-5" />
        {!isCollapsed && <span>{t('nav.logout')}</span>}
      </button>
    </div>
  );
}
